import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Components
import withLoader from '../../components/Loader/withLoader.js';
import WorkRequestsCreateLayout from './WorkRequestsCreateLayout';
import ReplaceContact from '../../components/Replace/ReplaceContact/ReplaceContact';
import CreateRequestForm from './CreateRequestForm/CreateRequestForm';
import HelpCard from '../../components/HelpCard/HelpCard.js';
import InfoIcon from '@material-ui/icons/InfoOutlined';

// Actions
import { actions as routingActions } from '../../ducks/routing.js';
import { actions as authActions } from '../../ducks/auth.js';
import { actions as appActions } from '../../ducks/app.js';
import { actions as customerActions } from '../../ducks/customer.js';
import { actions as propertiesActions } from '../../ducks/properties';

import { getString } from '../../helpers/stringHelpers.js';
import { getLoadedStatus } from '../../helpers/loaderHelpers';
import { hasRole } from '../../helpers/authHelpers.js';
import { isFeatureDisabled } from '../../helpers/outageHelpers';
import analyticsApi from '../../api/analytics';
import constants from '../../constants.js';
const stringsComponent = 'workRequestsCreate';

class WorkRequests extends React.Component {
  componentDidMount() {
    const { setAppBarTitle } = this.props;

    setAppBarTitle('Maintenance');
  }

  componentDidUpdate() {
    const { setUnsaved, tenancy, goDash } = this.props;

    setUnsaved(false);
    if (isFeatureDisabled('MAINTENANCE_WRITE', tenancy.data.area)) {
      goDash();
    }
  }

  shouldComponentUpdate(nextProps) {
    // Only rerender if not in a unloaded status.
    // This prevents the flash effect as APIs are loaded.
    if (getLoadedStatus(this.getLoadedStatuses(nextProps)) !== 'UNLOADED') {
      return true;
    }
    return false;
  }

  getLoadedStatuses(props = this.props) {
    const { tenancy, workRequests, spaces, appointments, roles } = props;
    const loaded = [tenancy.loaded, workRequests.open.loaded, spaces.loaded];
    return loaded;
  }

  render() {
    const {
      signout,
      inOutage,
      outageFrom,
      outageTo,
      outageMessage,
      toggleContactModal,
      workRequests,
      spaces,
      goWorkRequests,
      setUnsaved,
      createWorkRequest,
      clearRequestCreated,
      getWorkRequests,
      onLoadComplete,
      customerIsolating,
      tenancy,
    } = this.props;

    const WrappedWorkRequestsLayout = withLoader(WorkRequestsCreateLayout);

    const spacesData = spaces.data;

    const help = portalGuidances.find(
      (guidance) => guidance.Title === stringsComponent
    ) && (
      <HelpCard
        title={getString('help', 'MAINTENANCE_TITLE')}
        subheading={getString('help', 'MAINTENANCE_SUBHEADING')}
        content={
          portalGuidances.find(
            (guidance) => guidance.Title === stringsComponent
          ).Content
        }
        contact={
          portalGuidances.find(
            (guidance) => guidance.Title === stringsComponent
          ).Contact
        }
        faqs={
          portalGuidances.find(
            (guidance) => guidance.Title === stringsComponent
          ).FAQs
        }
        icon={<InfoIcon />}
        section={stringsComponent}
        toggleContactModal={toggleContactModal}
        isTop={false}
        gaEvent={analyticsApi.event}
        forceEnglish={true}
      />
    );

    const failureText = (
      <ReplaceContact
        content={portalContent.APP_ERROR_MESSAGE}
        action={toggleContactModal}
        isLink={true}
      />
    );

    return (
      <WrappedWorkRequestsLayout
        onError={signout}
        inOutage={inOutage}
        outageFrom={outageFrom}
        outageTo={outageTo}
        outageMessage={
          outageMessage && (
            <ReplaceContact
              content={outageMessage}
              action={toggleContactModal}
              isLink={true}
            />
          )
        }
        forceOutage={true}
        failureText={failureText}
        notFoundText={
          <ReplaceContact
            content={portalContent.APP_NOT_FOUND_MESSAGE}
            action={toggleContactModal}
            isLink={true}
          />
        }
        loaded={this.getLoadedStatuses()}
        form={
          <CreateRequestForm
            spaces={Array.isArray(spacesData) ? spacesData : []}
            goWorkRequests={goWorkRequests}
            onError={signout}
            failureText={failureText}
            setUnsaved={setUnsaved}
            contactAction={toggleContactModal}
            createWorkRequest={createWorkRequest}
            clearRequestCreated={clearRequestCreated}
            openWorkRequests={workRequests.open.data}
            workRequests={workRequests}
            gaEvent={analyticsApi.event}
            refresh={() => getWorkRequests('open')}
            customerIsolating={customerIsolating}
          />
        }
        help={help}
        onLoadComplete={onLoadComplete}
        backAction={goWorkRequests}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  tenancy: state.customer.tenancy,
  workRequests: state.customer.workRequests,
  appointments: state.customer.appointments,
  spaces: state.properties.spaces,
  inOutage: state.app.inOutage,
  outageFrom: state.app.outageFrom,
  outageTo: state.app.outageTo,
  outageMessage: state.app.outageMessage,
  customerIsolating: state.app.customerIsolating,
  roles: state.auth.roles,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...routingActions,
      ...appActions,
      ...authActions,
      ...customerActions,
      ...propertiesActions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(WorkRequests);
